import { OTP_LENGTH } from 'utils/constants';
import * as Yup from 'yup';

export const CHANGE_PASSWORD_SCHEMA = Yup.object().shape({
  password: Yup.string().required('Required'),
  passwordConfirmation: Yup.string().oneOf(
    [Yup.ref('password')],
    'Passwords do not match',
  ),
});

export type CHANGE_PASSWORD_FORM = Yup.InferType<typeof CHANGE_PASSWORD_SCHEMA>;

export const CHANGE_EXPIRED_PASSWORD_SCHEMA = Yup.object().shape({
  oldPassword: Yup.string().required('Required'),
  password: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .required('Required')
    .notOneOf(
      [Yup.ref('oldPassword')],
      'New Password and Old Password should not be match',
    ),
  passwordConfirmation: Yup.string().oneOf(
    [Yup.ref('password')],
    'Passwords do not match',
  ),
});

export type CHANGE_EXPIRED_PASSWORD_FORM = Yup.InferType<
  typeof CHANGE_EXPIRED_PASSWORD_SCHEMA
>;

export const LOGIN_VERIFICATION_SCHEMA = Yup.object().shape({
  otp: Yup.string().min(OTP_LENGTH).required('Required'),
});

export type LOGIN_VERIFICATION_FORM = Yup.InferType<
  typeof LOGIN_VERIFICATION_SCHEMA
>;

export const LOGIN_SCHEMA = Yup.object().shape({
  password: Yup.string().required('Required'),
  emailAddress: Yup.string().required('Required'),
  remember: Yup.boolean(),
});

export type LOGIN_FORM = Yup.InferType<typeof LOGIN_SCHEMA>;

export const FORGOT_PASSWORD_SCHEMA = Yup.object().shape({
  emailAddress: Yup.string().email('Invalid email').required('Required'),
});

export type FORGOT_PASSWORD_FORM = Yup.InferType<typeof FORGOT_PASSWORD_SCHEMA>;

export const SET_INVITE_PASSWORD_SCHEMA = Yup.object().shape({
  password: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .matches(
      // eslint-disable-next-line no-useless-escape
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\d\s!@#$%^&*()_+{}\[\]:;<>,.?~\\-]).+$/,

      // eslint-disable-next-line max-len
      'Password must include at least one lowercase letter, one uppercase letter, one number, and one special character (@$!%*?&)',
    )
    .required('Password is required'),
  passwordConfirmation: Yup.string()
    .oneOf([Yup.ref('password')], 'Passwords do not match')
    .required('Required'),
});

export type SET_INVITE_PASSWORD_FORM = Yup.InferType<
  typeof SET_INVITE_PASSWORD_SCHEMA
>;
